import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const StandardView = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M17.5 5.5H20A2.5 2.5 0 0 1 22.5 8v.5h-5z'
          fill='currentColor'
          stroke='currentColor'
        />
        <path
          d='M17.5 17.5h5v.5a2.5 2.5 0 0 1-2.5 2.5h-2.5z'
          fill='currentColor'
          stroke='currentColor'
        />
        <rect
          x='17.5'
          y='11.5'
          width='5'
          height='3'
          fill='currentColor'
          stroke='currentColor'
        />
        <path
          d='M3.75 9.8c0-.852 0-1.447.038-1.91.037-.453.107-.714.207-.911a2.25 2.25 0 0 1 .984-.984c.197-.1.458-.17.912-.207.462-.037 1.057-.038 1.909-.038h6.45v14.5H7.8c-.852 0-1.447 0-1.91-.038-.453-.038-.714-.107-.911-.207a2.25 2.25 0 0 1-.984-.983c-.1-.198-.17-.459-.207-.913-.037-.462-.038-1.057-.038-1.909z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path d='M16.75 4.905h3a3 3 0 0 1 3 3v1h-6z' fill='currentColor' />
        <path d='M16.75 16.905h6v1a3 3 0 0 1-3 3h-3z' fill='currentColor' />
        <rect x='16.749' y='10.905' width='6' height='4' fill='currentColor' />
        <path
          d='M2.75 7.905a3 3 0 0 1 3-3h9v16h-9a3 3 0 0 1-3-3z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
